<p class="text is-level-2 mb-1">
    {{label}}&nbsp;<span class="asterisk">*</span>
</p>
